import React from "react";
import AuthContext from "../../../contexts/AuthContext";
import { StudentStatus } from "../../../models/interfaces/student/StudentStatus";
import ExamList from "../exam-list/ExamList";
import ExamRequest from "../exam-request/ExamRequest";
import './ExamArea.scss';
import ExamAreaState, { ExamAreaProps } from "./ExamArea.models";
import { ExamTypes } from "../../../models/interfaces/exams/exam/ExamTypes";
import BrowserAlert from "../../shared/browser-alert/BrowserAlert";

export default class ExamArea extends React.PureComponent<ExamAreaProps, ExamAreaState> {

    static contextType = AuthContext;
    constructor(props: any) {
        super(props);
        this.state = {
            statusPage: 0,
            userInformation: {
                education: {},
                personal: {},
                system: {},
            },
        };
    }

    componentDidMount() {
        if (this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.changeTab(Number.parseInt(this.props.statusPage))

        this.setState({ userInformation: this.context.userInformation });

    }

    componentDidUpdate(prevProps: any) {
        if (prevProps.statusPage !== this.props.statusPage && this.props.statusPage !== null && this.props.statusPage !== undefined)
            this.changeTab(Number.parseInt(this.props.statusPage))
        this.setState({ userInformation: this.context.userInformation });
    }

    changeTab = (status: number) => {
        this.setState({
            statusPage: status
        })
    }

    render(): React.ReactNode {
        let statusPage = this.state.statusPage;
        let canRequestExam = this.state.userInformation.system.status === StudentStatus.Archive || this.state.userInformation.system.status === StudentStatus.InitialRegistration;
        let view;

        switch (statusPage) {
            case 0:
                view = <ExamList currentExam={true} onlyShowProficiencyTest={canRequestExam} />;
                break;
            case 1:
                view = <ExamList onlyFutureExams={true} examTypes={ExamTypes.ExhaustiveTest} currentExam={false} onlyShowProficiencyTest={canRequestExam} />
                break;
            case 3:
                view = <ExamList examTypes={ExamTypes.ExhaustiveTest} currentExam={false} onlyShowProficiencyTest={true} />;
                break;
            case 2:
                view = <ExamRequest />;
                break;
        }

        return <>
            <div className="dropdown-list pt-4" style={{ height: "80vh" }}>
                {view}
            </div>
            <BrowserAlert />
        </>;
    }
}